var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignHorizontalCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M450 976V766H240V666h210V486H120V386h330V176h60v210h330v100H510v180h210v100H510v210h-60Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignHorizontalCenter);
export default __webpack_public_path__ + "static/media/align_horizontal_center.9e8f2ba1fea0084ab7d0add8bc75667a.svg";
export { ForwardRef as ReactComponent };